module.exports = __webpack_public_path__ + "img/oar-admin.448f34f5.jpg";